import React from 'react';
import { Link } from 'react-router-dom';
import { useDeckModal } from '../../contexts/DeckModalContext';
import './Footer.css';

const Footer: React.FC = () => {
  const { openDeckModal } = useDeckModal();
  const currentYear = new Date().getFullYear();

  return (
    <footer>
      <div className="foot-grid">
        <div>
          <Link to="/" className="foot-logo-link">
            <img
              src="/assets/logos/kyro-logo-white.png"
              alt="Kyro - Alternative Investments & Corporate Advisory"
              className="foot-logo-img"
            />
          </Link>
          <p className="foot-tag">
            Institutional-grade alternative investments delivering structured alpha through disciplined execution.
          </p>
        </div>
        <div>
          <div className="foot-col-title">Pages</div>
          <div className="foot-links">
            <Link to="/" className="foot-link">Home</Link>
            <Link to="/about" className="foot-link">About</Link>
            <Link to="/asset-management" className="foot-link">Asset Management</Link>
            <Link to="/advisory" className="foot-link">Advisory</Link>
            <Link to="/insights" className="foot-link">Insights</Link>
            <Link to="/investor-relations" className="foot-link">Investor Relations</Link>
            <Link to="/contact" className="foot-link">Contact</Link>
          </div>
        </div>
        <div>
          <div className="foot-col-title">Fund</div>
          <div className="foot-links">
            <Link to="/asset-management" className="foot-link">Kyro India Opportunities Fund – I</Link>
            <span className="foot-link" style={{ cursor: 'default' }}>(Scheme of Kyro Alternative Investment Trust – Category-II AIF)</span>
            <span className="foot-link" style={{ cursor: 'default' }}>SEBI Registration No.: IN/AIF2/26-27/2191</span>
            <button type="button" onClick={openDeckModal} className="foot-link">Request Fund Deck</button>
          </div>
        </div>
        <div>
          <div className="foot-col-title">Contact</div>
          <div className="foot-links">
            <a className="foot-link" href="mailto:compliance@kyrocapital.in">compliance@kyrocapital.in</a>
            <a className="foot-link" href="tel:+917611111102">76 111 111 02</a>
            <span className="foot-link" style={{ cursor: 'default' }}>
              303, Unity One, Rajiv Gandhi Square, Indore – 452001
            </span>
          </div>
        </div>
      </div>
      <div className="foot-compliance">
        <div className="foot-compliance-top">
          <div>
            <div className="foot-compliance-title">Compliance Resources</div>
            <div className="foot-compliance-links">
              <Link to="/stewardship-code" className="foot-compliance-link">
                Stewardship Code
              </Link>
              <Link to="/grievance-redressal" className="foot-compliance-link">
                Grievance Redressal Policy
              </Link>
              <a href="https://scores.sebi.gov.in/" target="_blank" rel="noopener noreferrer" className="foot-compliance-link">
                SCORES (SEBI Complaints)
                <span className="foot-ext-icon" aria-hidden>↗</span>
              </a>
              <a href="https://smartodr.in/" target="_blank" rel="noopener noreferrer" className="foot-compliance-link">
                SMARTODR (Dispute Resolution)
                <span className="foot-ext-icon" aria-hidden>↗</span>
              </a>
              <a href="https://www.sebi.gov.in/legal/master-circulars/dec-2023/master-circular-for-online-resolution-of-disputes-in-the-indian-securities-market_80236.html" target="_blank" rel="noopener noreferrer" className="foot-compliance-link">
                SEBI Master Circular on ODR
                <span className="foot-ext-icon" aria-hidden>↓</span>
              </a>
              <span className="foot-compliance-contact" style={{ marginTop: '0.5rem', display: 'block' }}>
                <a href="mailto:compliance@kyrocapital.in" className="foot-compliance-link">compliance@kyrocapital.in</a>
                {' or '}
                <a href="tel:+917611111102" className="foot-compliance-link">76 111 111 02</a>
              </span>
            </div>
          </div>
          <div className="foot-compliance-entity">
            <div>Kyro Asset Management Private Limited</div>
            <div>Kyro Capital Private Limited</div>
          </div>
        </div>
        <div className="foot-compliance-disclaimer">
          <strong>Disclaimer:</strong> You acknowledge and confirm that by accessing the website, you are seeking information relating to the organisation of your own accord and that there has been no form of solicitation, advertisement or inducement by the organisation. Any part of the content is not, and should not be construed as, an offer or solicitation to buy or sell any securities or make any investments or any products. No material/information provided on this website should be construed as investment advice. Any action on your part on the basis of the said content is at your own risk and responsibility.
        </div>
      </div>
      <div className="foot-bottom">
        <div className="foot-copy">
          © {currentYear} Kyro Asset Management Private Limited. All rights reserved.<br />
          © {currentYear} Kyro Capital Private Limited. All rights reserved.
        </div>
        <div className="foot-legal">
          <Link to="/investor-login">Investor Login</Link>
          <Link to="/admin-login">Admin</Link>
          <Link to="/privacy-policy">Privacy Policy</Link>
          <Link to="/disclaimer">Disclaimer</Link>
          <Link to="/stewardship-code">Stewardship Code</Link>
          <Link to="/grievance-redressal">Grievance Redressal</Link>
        </div>
      </div>
      <div className="foot-disc">
        Investment Manager for SEBI Registered Category II AIF (Reg. No. IN/AIF2/26-27/2191). This website is for informational purposes only and does not constitute an offer to sell or solicitation of an offer to buy any securities. Investment in the fund involves significant risk. Past performance is not indicative of future results. For eligible investors only. Confidential - For Private Circulation Only.
      </div>
    </footer>
  );
};

export default Footer;
